import {
  ButtonBase,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  InputLabel,
  Paper,
  RadioGroup,
  Select,
  Stack,
} from '@mui/material'
import { Box } from '@mui/system'
import * as React from 'react'
import { useScreenContext } from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'
import { tsScreenCollection } from '../../../Typescript/DB_Interface'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { DeleteForever } from '@mui/icons-material'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'
import { useQueryClient } from 'react-query'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { LoadingButton } from '@mui/lab'
import { ReadOnlyTextField } from '../../../garvan-react/Components/ReadOnlyTextField'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useLocation } from 'react-router-dom'

function CollectionCard({
  index,
  collection,
  setCollections,
  setOpen,
  setMode,
  readOnly,
}: {
  index: number
  collection: Partial<tsScreenCollection>
  readOnly: boolean
  setCollections?: any
  setOpen?: any
  setMode?: any
}) {
  const { pathname } = useLocation()
  const clone = pathname.includes('/clone')
  const { loginConfig } = useUserContext()
  const { editable } = useScreenContext()
  const queryClient = useQueryClient()
  const { setMessage } = useMessagePopupContext()

  //TODO:  Merge with ScreenCollectionDetails

  const { mutate: deleteCollection, isLoading } = useStuartMutate(
    `/screen/deleteCollection.php?ScreenCollectionID=${collection.ScreenCollectionID}`,
    async (data) => {
      if (data?.message) {
        setMessage({
          subject: 'Unable to save result comment',
          message: data.message,
          severity: 'warning',
        })
      } else {
        await queryClient.invalidateQueries({
          queryKey: ['PhpAPI', '/stuart', '/screen/getScreenCollections.php'],
        })
      }
    },
  )

  return (
    <Stack
      direction={'row'}
      gap={stackGap.row}
      width={1}
    >
      <ButtonBase
        onClick={() => {
          setOpen({ ...collection, index: index })
          setMode('edit')
        }}
        sx={{ width: 1 }}
        disabled={!editable || readOnly}
      >
        <Paper
          elevation={3}
          sx={{ width: 1, p: 2 }}
        >
          <Stack
            width={1}
            gap={stackGap.col}
          >
            <Stack
              width={1}
              gap={stackGap.row}
              direction={'row'}
            >
              <ReadOnlyTextField
                label="Sample Type"
                value={getCodeSetLabelLookup(
                  loginConfig,
                  ['SampleRunTypeID'],
                  collection?.SampleType,
                )}
                fullWidth
              />
              <ReadOnlyTextField
                label="Destination Lab"
                value={getCodeSetLabelLookup(
                  loginConfig,
                  ['KV-Facilities'],
                  collection?.DestinationFacilityID,
                )}
                fullWidth
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled
                    checked={collection.Rebill === 'Y'}
                  />
                }
                label="Rebill"
              />
            </Stack>
            <Stack
              width={1}
              gap={stackGap.row}
              direction={'row'}
            >
              <ReadOnlyTextField
                sx={{ flex: 1 }}
                label="Sample represents"
                value={
                  getCodeSetLabelLookup(
                    loginConfig,
                    ['ScreenCriteriaID'],
                    collection?.Criteria,
                  ) ?? ''
                }
              />
              <FormControl sx={{ flex: 3 }}>
                <InputLabel>Sampled items</InputLabel>
                <Select
                  label="Sampled items"
                  multiple
                  readOnly
                  value={(collection?.CriteriaDetails ?? '').split(',') ?? []}
                  IconComponent={() => <div />}
                  renderValue={(detail) => (
                    <RadioGroup
                      sx={{
                        flexWrap: 'wrap',
                        gap: 1 / 2,
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      {detail.map((value) => (
                        <Box>
                          <Chip
                            key={value}
                            label={value.trim()}
                          />
                        </Box>
                      ))}
                    </RadioGroup>
                  )}
                ></Select>
              </FormControl>
            </Stack>
            <Stack
              width={1}
              gap={stackGap.row}
              direction={'row'}
            >
              <ReadOnlyTextField
                sx={{ flex: 1 }}
                label="Source"
                value={
                  collection?.SampleSource ?
                    !isNaN(parseInt(collection.SampleSource)) ?
                      getCodeSetLabelLookup(
                        loginConfig,
                        ['SampleSourceID'],
                        collection.SampleSource,
                      )
                    : collection.SampleSource
                  : ''
                }
              />
              <FormControl sx={{ flex: 3 }}>
                <InputLabel>Tests</InputLabel>
                <Select
                  label="Tests"
                  multiple
                  readOnly
                  value={collection?.Tests ? collection.Tests.split(',') : []}
                  IconComponent={() => <div />}
                  renderValue={(detail) => (
                    <RadioGroup
                      sx={{
                        flexWrap: 'wrap',
                        gap: 1 / 2,
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      {detail.length > 1 ?
                        detail.map((value) => (
                          <Box>
                            <Chip
                              key={value}
                              label={value.trim()}
                            />
                          </Box>
                        ))
                      : <Box>{detail}</Box>}
                    </RadioGroup>
                  )}
                ></Select>
              </FormControl>
            </Stack>
            <ReadOnlyTextField
              fullWidth
              label="Collection Instructions"
              value={collection.CollectionInstructions}
            />
          </Stack>
        </Paper>
      </ButtonBase>
      {editable && (
        <Box>
          <LoadingButton
            loading={isLoading}
            variant="outlined"
            color="error"
            disabled={!editable}
            onClick={() => {
              if (clone) {
                setCollections((c: any) => {
                  const newCs = c
                  newCs.splice(index, 1)
                  return [...newCs]
                })
              } else {
                deleteCollection()
              }
            }}
          >
            <DeleteForever />
          </LoadingButton>
        </Box>
      )}
    </Stack>
  )
}

export default CollectionCard
